<template>
  <v-container class="easy-home">
    <v-spacer style="margin-top: 8rem;"></v-spacer>
    <div class="header-logo"></div>
    <v-spacer style="margin-top: 2rem;"></v-spacer>
    <div class="header-title">CIOF へようこそ</div>
    <div class="header-subtitle">CIOFで新しいものづくりを始めましょう</div>
    <v-spacer style="margin-top: 2rem;"></v-spacer>
    <v-btn
        class="go-easy"
        to="/easy"
        v-ripple="{class: 'blue--text'}"
        elevation="1"
        rounded
        large>
      かんたんモードを始める
    </v-btn>
    <v-spacer style="margin-top: 1.5rem;"></v-spacer>
    <v-btn
        class="go-normal"
        elevation="1"
        @click="goNormal"
        rounded>
      通常モードに戻る
    </v-btn>
  </v-container>
</template>

<script>
import PageStoreMixin, {mapPageStores} from "@/utils/PageStoreMixin";

export default {
  name: "EasyHome",
  mixins: [PageStoreMixin],
  computed: {
    ...mapPageStores({
      useEasyHome: {alt: true, key: 'app.useEasyHome'},
    }),
  },
  methods: {
    goNormal() {
      this.useEasyHome = false;
    }
  }
}
</script>

<style lang="scss" scoped src="./easy.scss"></style>
<style lang="scss" scoped>
.easy-home {
  .header-logo {
    display: inline-block;
    width: 300px;
    height: 100px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url("../../../assets/logo-small.svg");
  }

  .v-btn.go-easy {
    padding: 1.8rem 4rem;
    font-size: 1.5rem;
    background-color: #F2F9FF;

    &::before {
      color: #008aff;
    }
  }

  .v-btn.go-normal {
    padding: 1rem 3rem;
    background-color: white;
  }
}
</style>
